import './NotMonitoredLabel.scss';
import { InfoCircleOutlined } from '@ant-design/icons';
import { NavLink } from 'react-router-dom';
import React from 'react';
import { SonarText } from '@ui/text';
import { Tooltip } from 'antd';
import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
export const NotMonitoredLabel = () => React.createElement(SonarText, { className: 'not-monitored' },
    COPY_SPECIFIC.NOT_MONITORED,
    React.createElement(Tooltip, { title: React.createElement(React.Fragment, null,
            COPY_SPECIFIC.NOT_MONITORED_TOOLTIP_START,
            React.createElement(NavLink, { to: FULL_ROUTES.DATA_SECURITY_APPLICATION_SETUP }, COPY_SPECIFIC.HERE),
            COPY_SPECIFIC.NOT_MONITORED_TOOLTIP_END) },
        React.createElement(InfoCircleOutlined, null)));
